module.exports = false;



//////////////////
// WEBPACK FOOTER
// /builds/intothesource/vadain/stalenservice-without-login/node_modules/core-js/modules/_library.js
// module id = 18
// module chunks = 13